import { database } from './firebase';
import { ref, set, get } from 'firebase/database';

// Available board styles
export const BOARD_STYLES = [
  { id: 'brown', name: 'Brown', colors: { light: '#f0d9b5', dark: '#b58863' } },
  { id: 'blue', name: 'Blue', colors: { light: '#dee3e6', dark: '#8ca2ad' } },
  { id: 'gray', name: 'Gray', colors: { light: '#e8e8e8', dark: '#9e9e9e' } },
  { id: 'purple', name: 'Purple', colors: { light: '#e8d7f1', dark: '#9c6bb5' } },
  { id: 'tournament', name: 'Green', colors: { light: '#eeeed2', dark: '#769656' } },
];

// Available piece sets
export const PIECE_SETS = [
  { id: 'neo', name: 'Neo' },
  { id: 'classic', name: 'Classic' },
  { id: 'modern', name: 'Modern' },
  { id: 'alpha', name: 'Alpha' },
  { id: 'bases', name: 'Bases' },
  { id: 'cases', name: 'Cases' },
  { id: 'condal', name: 'Condal' },
  { id: 'game_room', name: 'Game Room' },
  { id: 'glass', name: 'Glass' },
  { id: 'gothic', name: 'Gothic' },
  { id: 'lolz', name: 'Lolz' },
  { id: 'marble', name: 'Marble' },
  { id: 'maya', name: 'Maya' },
  { id: 'metal', name: 'Metal' },
  { id: 'neon', name: 'Neon' },
  { id: 'newspaper', name: 'Newspaper' },
  { id: 'ocean', name: 'Ocean' },
  { id: 'sky', name: 'Sky' },
  { id: 'space', name: 'Space' },
  { id: 'tigers', name: 'Tigers' },
  { id: 'tournament', name: 'Tournament' },
  { id: 'unicode', name: 'Unicode (Symbols)' },
];

// Default preferences
const DEFAULT_PREFERENCES = {
  boardStyle: 'brown',
  pieceSet: 'neo',
  useImages: true, // Use images if available, fall back to Unicode
};

/**
 * Get user's chess preferences
 */
export const getChessPreferences = async (userId) => {
  if (!userId) return DEFAULT_PREFERENCES;

  try {
    const prefsRef = ref(database, `userPreferences/${userId}/chess`);
    const snapshot = await get(prefsRef);

    if (snapshot.exists()) {
      return { ...DEFAULT_PREFERENCES, ...snapshot.val() };
    }

    return DEFAULT_PREFERENCES;
  } catch (error) {
    console.error('Error loading chess preferences:', error);
    return DEFAULT_PREFERENCES;
  }
};

/**
 * Save user's chess preferences
 */
export const saveChessPreferences = async (userId, preferences) => {
  if (!userId) return;

  try {
    const prefsRef = ref(database, `userPreferences/${userId}/chess`);
    await set(prefsRef, {
      ...DEFAULT_PREFERENCES,
      ...preferences,
      updatedAt: Date.now(),
    });
  } catch (error) {
    console.error('Error saving chess preferences:', error);
    throw error;
  }
};

/**
 * Get board style colors
 */
export const getBoardColors = (boardStyleId) => {
  const style = BOARD_STYLES.find(s => s.id === boardStyleId);
  return style ? style.colors : BOARD_STYLES[0].colors;
};

/**
 * Get piece image path
 */
export const getPieceImagePath = (pieceSet, piece) => {
  if (!piece || piece === '' || pieceSet === 'unicode') return null;
  // Convert piece notation (e.g., 'wK') to lowercase (e.g., 'wk')
  const pieceLower = piece.toLowerCase();
  return `/chess/pieces/${pieceSet}/${pieceLower}.png`;
};

/**
 * Check if piece images exist for a set
 */
export const checkPieceSetAvailable = async (pieceSet) => {
  if (pieceSet === 'unicode') return true;

  try {
    // Try to load one piece to check if the set exists
    const testImage = new Image();
    const promise = new Promise((resolve) => {
      testImage.onload = () => resolve(true);
      testImage.onerror = () => resolve(false);
    });
    testImage.src = getPieceImagePath(pieceSet, 'wK');
    return await promise;
  } catch (error) {
    return false;
  }
};
